
import { AbstractControl } from '@angular/forms';
import {
    FormGroup,
    ValidationErrors,
    ValidatorFn,
    Validators,
  } from '@angular/forms';
 

  export function optionalField(firstControl): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
         
        var field = control.get(firstControl).value;

        if (field.length >= 0 && field.length <= 40) {
            return null;
        } else {
            
            return { optionalField: 'Maximum length is 40 characters' };
        }
       
       
    };
  }

